// extracted by mini-css-extract-plugin
export default {"adjustedIcon":"CustomerPurchaseAdviceFeeCard_adjustedIcon__MQDNB"};